export default function SvgVideo3() {
    return (
      <>
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20px"
    cursor="pointer"
    viewBox="0 -1.5 20 20"
  >
    <g
      fill="none"
      fillRule="evenodd"
      stroke="none"
      strokeWidth="1"
    >
      <g fill="#00cc00" transform="translate(-300 -3921)">
        <g transform="translate(56 160)">
          <path d="M262 3771.312V3773.77l-2.233-1.437L262 3771.1v.212zm-6 3.597c0 .569-.448 1.03-1 1.03h-8c-.552 0-1-.461-1-1.03v-4.121c0-.569.448-1.03 1-1.03h8c.552 0 1 .461 1 1.03v4.121zm-7.89-9.788c.552 0 1 .463 1 1.03 0 .568-.448 1.03-1 1.03-.551 0-1-.462-1-1.03 0-.567.449-1.03 1-1.03zm5-2.06c1.103 0 2 .924 2 2.06 0 1.137-.897 2.06-2 2.06-1.102 0-2-.923-2-2.06 0-1.136.898-2.06 2-2.06zm9.36 5.105l-4.47 2.874v-1.798c0-1.007-.62-1.844-1.548-2.022.357-.616.617-1.33.617-2.099 0-2.276-1.77-4.121-3.979-4.121-1.617 0-2.991.993-3.622 2.415a2.886 2.886 0 00-1.363-.354c-1.657 0-2.997 1.383-2.997 3.09 0 .431.004.841.159 1.213-.697.323-1.267 1.04-1.267 1.878v6.182c0 1.138 1.062 2.576 2.167 2.576h10c1.104 0 1.833-1.438 1.833-2.576v-1.798l4.47 2.875c.667.429 1.53-.065 1.53-.874v-6.588c0-.808-.863-1.302-1.53-.873z"></path>
        </g>
      </g>
    </g>
  </svg>
  </>
  );
}
